import { gql } from 'graphql-tag';

const brandId = gql`
  fragment BrandId on Brand {
    id
  }
`;

export const BrandFragments = {
  id: brandId,
  filterBrandNodeFields: gql`
    fragment FilterBrandNodeFields on Brand {
      ...BrandId
      externalId
      name
    }
    ${brandId}
  `,
};
